import React from 'react';
import { Reveal } from './Reveal';
const stats = [['7', 'COMPLETE VOLUMES'], ['420+', 'PAGES OF CONTENT'], ['70', 'READY-TO-TEACH LESSONS'], ['AGES 9–17', 'ONE CLEAR PROGRESSION']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-159" data-mp="1o9u2byyc10kg">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-160" data-mp="1jd3ntg26ed15">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-161" data-mp="1efby8sp07304" data-mpi={index}>
          <span className="mb-1 font-serif text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-162" data-mp="15ke2lduh1c53">{value}</span>
          <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-163" data-mp="10mlzdnodm3ll">{label}</span>
        </div>)}
      </Reveal>
    </section>;
}